import {createSlice} from '@reduxjs/toolkit';
import {SpecialityModalState} from '../../interfaces/connected-components/specialityModal';

/**
 * Represents the initial state for the Speciality modal slice.
 * @type {SpecialityModalState}
 */
const initialState: SpecialityModalState = {
  isVisible: false,
};

/**
 * Represents a Redux slice for managing the Speciality modal state.
 * @type {Slice<SpecialityModalState>}
 */
export const specialityModalSlice = createSlice({
  name: 'specialityModal',
  initialState,
  reducers: {
    /**
     * Action to show the Speciality modal with the provided data.
     * @returns {void}
     */
    showSpecialityModal: (state): void => {
      state.isVisible = true;
    },
    /**
     * Action to hide the Speciality modal.
     * @param {SpecialityModalState} state - The current state of the Speciality modal.
     * @returns {void}
     */
    hideSpecialityModal: (state): void => {
      state.isVisible = false;
    },
  },
});

/**
 * Action creators for the Speciality modal slice.
 */
export const {showSpecialityModal, hideSpecialityModal} =
  specialityModalSlice.actions;

/**
 * The reducer function for the Speciality modal slice.
 * @type {Reducer<SpecialityModalState>}
 */
export default specialityModalSlice.reducer;
